export function isHttpsRedirectUrl(value: string, previous?: string) {
  const trimmed = value.trim()
  if (trimmed === '') return true
  try {
    const protocol = new URL(trimmed).protocol
    return (
      protocol === 'https:' ||
      (protocol === 'http:' && previous !== undefined && trimmed === previous.trim())
    )
  } catch {
    return false
  }
}
